(function() {
  document.addEventListener('DOMContentLoaded', () => {
    const target = document.body;

    const observer = new MutationObserver((mutationsList) => {
      console.log(window.cpbColor, 'window.cpbColor')
      for (const mutation of mutationsList) {
        const url = new URL(window.location.href);
        const variantId = url.searchParams.get('variant');
        if (variantId && Array.isArray(window?.cpbColor)) {
          const redirectButton = document.querySelector('.cpb-redirect')
          const productVariant = window.shopifyProduct.variants.filter(variant => variant.id === +variantId )
          const selectedColor = window?.cpbColor.filter(color => color.includes(productVariant[0].title))
          redirectButton.href = selectedColor[0].split(';')[2]
        } else {
          const redirectButton = document.querySelector('.cpb-redirect')
          const shopifyDefaultVariant = window?.ShopifyAnalytics.meta.product.variants[0]
          const productVariant = window.shopifyProduct.variants.filter(variant => variant.id === shopifyDefaultVariant.id )
          const selectedColor = window?.cpbColor.filter(color => color.includes(productVariant[0].title))
          redirectButton.href = selectedColor[0].split(';')[2]
        }
      }
    });
    
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
})()
